<template>
    <div>
      <b-button @click="convert">Generar shape</b-button>
    </div>
</template>

<script>
  import shpwrite from 'shp-write'
  export default {
        name: "shp-json",
      props:['tramos'],
      methods:{
          convert(){
            var options = {
              folder: ''+this.tramos[0].properties.IDSV,
              types: {
                point: 'mypoints',
                polygon: 'mypolygons',
                line: 'mylines',
                polyline:"SC_"+this.tramos[0].properties.IDSV
              }
            };
            shpwrite.download({
              type: 'FeatureCollection',
              features: this.tramos
            }, options);
          }
      }
    }
</script>

<style scoped>

</style>
